export { default as LockOpenIcon } from './LockOpenIcon';
